
import React from "react";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import { i18nManager } from "../../i18n";
import Breadcrumb from "../shared/Breadcrumb";
import * as ReactRouterDom from "react-router-dom";
import { CacheManager, Debugger, Utils } from "../../utils";
import { SupportContactService, ISupportContact, IPlatform, SanitizedResponse } from "../../services";

function ContactUs() {
    const labels = i18nManager.Labels.contact;
    const { platform } = ReactRouterDom.useParams();
    const activePlatform = CacheManager.getPlatform(platform);
    const supportContactService = SupportContactService.getInstance();
    const [supportContact, setSupportContact] = React.useState<ISupportContact>({} as ISupportContact);

    React.useEffect(() => {
        if (!activePlatform) return;
        supportContactService.querySupportContacts({ sort: "id,DESC", "platform.external_id": activePlatform?.external_id, size: 1 }).then(({ apiResponse }: SanitizedResponse<any>) => {
            Debugger.log("ContactUs:useEffect:querySupportContacts", apiResponse.data);
            if (apiResponse.data?.content?.length) setSupportContact(apiResponse.data.content[0]);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, []);

    return (<div className="support">
        <Header title={labels.title} />
        <Breadcrumb breadCrumbs={[{ label: labels.title, location: window.location.href }]} />
        <div className="contact-us">
            <div className="links">
                {labels.links.map((link) => (<a key={link.title} href={"/" + platform + link.location?.replace("${phone}", (supportContact?.addresses?.length ? supportContact?.addresses[0].phone : "000"))}
                    onClick={!link.location ? () => performLinkAction(link) : undefined}>
                    <img alt={link.title} src={link.image} />
                    <span className="title">{link.title}</span>
                    <span className="desc">{link.desc}</span>
                </a>))}
            </div>
            <div className="detail">
                <span className="title">{labels.contact_us}</span>
                <span className="desc">{supportContact?.description}</span>
                {supportContact?.weekdays_opening_hours && (<span className="date">{labels.monday_to_friday} | {supportContact?.weekdays_opening_hours.open} - {supportContact?.weekdays_opening_hours.close}</span>)}
                {supportContact?.weekends_opening_hours && (<span className="date">{labels.weekend} | {supportContact?.weekends_opening_hours.open} - {supportContact?.weekends_opening_hours.close}</span>)}
                {supportContact?.holidays_opening_hours && (<span className="date">{labels.holidays} | {supportContact?.holidays_opening_hours.open} - {supportContact?.holidays_opening_hours.close}</span>)}
                <span className="marginal" />
                <div>
                    <i className="fa fa-phone" />
                    <span>{supportContact?.addresses?.map(a => a.phone).join(",")}</span>
                </div>
                <div>
                    <i className="fa fa-envelope" />
                    <span>{supportContact?.addresses?.map(a => a.email).join(",")}</span>
                </div>
            </div>
        </div>
        <Footer />
    </div>);

    async function performLinkAction(link: any) {
        Debugger.log("ContactUs:performLinkActions", link);
    }

}

export default ContactUs;
